// ニュースイベント掲示のエンティティ
export class NewsEventNotice {
  // 掲示ID DB型(*autokey)
  public notice_id?: number;
  // タイトル DB型(*varchar1024)
  public title?: string;
  // URL DB型(mediumtext)
  public contents_url?: string;
  // 開始日時 DB型(datetime)
  public notice_start_dt?: Date;
  // 終了日時 DB型(datetime)
  public notice_end_dt?: Date;
  // 種類 DB型(*varchar20)
  public notice_type?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): NewsEventNotice {
    const entity = new NewsEventNotice();
    entity.notice_id = record['notice_id'];
    entity.title = record['title'];
    entity.contents_url = record['contents_url'];
    entity.notice_start_dt = record['notice_start_dt'];
    entity.notice_end_dt = record['notice_end_dt'];
    entity.notice_type = record['notice_type'];
    return entity;
  }
  static getTypeFitEntity(value: any): NewsEventNotice {
    const entity = new NewsEventNotice();
    entity.notice_id = value.notice_id;
    entity.title = value.title;
    entity.contents_url = value.contents_url;
    entity.notice_start_dt = value.notice_start_dt;
    entity.notice_end_dt = value.notice_end_dt;
    entity.notice_type = value.notice_type;
    return entity;
  }
}
